import CloseableDialog from 'components/modal-dialog/CloseableDialog';
import React, { useEffect } from 'react';
import { Trans } from '@lingui/macro';
import { TextField, Typography } from '@mui/material';
import LoaderMessage from 'components/loader/LoaderMessage';
import { httpClient } from '@cocoplatform/coco-rtc-client';


export default function PlaySpaceModal(
    p: {
        onClose?: () => void;
        spaceCode?: string;
    }
) {
    const hasSpaceCode = !!p.spaceCode;

    const [spaceCode, setSpaceCode] = React.useState(p.spaceCode);
    const [isLoading, setIsLoading] = React.useState(false);

    async function getSpaceByPlayCode(playCode: string) {
        const space = await httpClient.get(`/spaces/play-code/${playCode}`);
        return space;
    }

    useEffect(() => {
        if (hasSpaceCode) {
            setIsLoading(true);
            getSpaceByPlayCode(spaceCode!).then((res) => {
                const space = res.data;
                window.location.href = `/app/spaces/${space.id}/editor`;
            });
        }
    }, [hasSpaceCode]);

    return (
        <CloseableDialog
            onClose={p.onClose}
            fullWidth
            maxWidth='md'
        >
            {!hasSpaceCode && (
                <div>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 'bold',
                        }}
                    >
                        <Trans>Enter a space code to play a space together with your friends!</Trans>
                    </Typography>
                    <TextField
                        autoFocus
                        onChange={(e) => {

                        }}
                        sx={{
                            marginTop: '1rem',
                        }} variant="filled" fullWidth placeholder="Name" InputProps={{
                            sx: {
                                backgroundColor: "var(--coco-input-bg)",
                                height: '2rem',
                            }
                        }} />
                </div>
            )}
            {hasSpaceCode && (
                <div>
                    <LoaderMessage
                        isLoading={isLoading}
                        message={`Joining space ${p.spaceCode}...`}
                        mode="subtle"
                    />
                </div>
            )}
        </CloseableDialog >
    )
}